module.exports = __webpack_public_path__ + "img/burgundy-85.b99412d4.png";